import type { ElementType } from "react";
import { forwardRef } from "react";

interface ObscuredProps {
  children?: React.ReactNode;
  component?: ElementType;
  // The props of `component`, passed through.
  [key: string]: unknown;
}

/**
 * Wrapper component that adds data-openreplay-obscured attribute
 * to hide sensitive data from session recordings.
 * Uses forwardRef so refs (e.g. from react-otp-input) reach the underlying element.
 */
export const ObscuredText = forwardRef<unknown, ObscuredProps>(
  ({ children, component = "span", ...props }, ref) => {
    // forwardRef drops the named props of a type with an index signature, so `component`
    // arrives as unknown; it is the ElementType ObscuredProps declares.
    const Component = component as ElementType;

    return (
      <Component {...props} ref={ref} data-openreplay-obscured="">
        {children}
      </Component>
    );
  },
);

ObscuredText.displayName = "ObscuredText";
